import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

    public error = false;
    public loginForm: UntypedFormGroup;
    public showPassword = false;
    constructor(
        protected formBuilder: UntypedFormBuilder,
        protected router: Router,
        protected authService: AuthService,
        protected dialogService: NbDialogService
    ) { }

    ngOnInit(): void {

        this.loginForm = this.formBuilder.group({
            email: [null, Validators.required],
            password: [null, Validators.required]
        });
    }

    public loginAction(): void {

        this.error = false;
        const values = this.loginForm.getRawValue();

        this.authService.login(values.email, values.password).subscribe(
            connected => {
                if (connected) {
                    // Navigate to home, invitations will be handled on compare page
                    this.router.navigate(['/']);
                } else {
                    this.error = true;
                }
            }
        );
    }
}
